import { OptionItemSelector } from '@/src/app/main/(tabs)/card/card-management/payment/optionItemSelector'
import { PaymentCardInformation } from '@/src/app/main/(tabs)/card/card-management/_common/paymentCardInformation'
import { Button } from '@/src/common/components/Button'
import { ScrollView, StyleSheet } from 'react-native'
import { usePaymentScreen } from '@/src/experiences/card-payments/hooks/usePaymentScreen'
import { CardPaymentsE2E } from '@/src/experiences/card-payments/e2e'
import { CardPaymentsComponents as Components } from '@/src/experiences/card-payments/components'
import type { ComponentProps, FunctionComponent } from 'react'
import { provideCardPlatform } from '@/src/experiences/card-platform/provideCardPlatform'
import { LegacyAutoPayScheduleReview } from '@/src/experiences/card-payments/screens/AutoPayScheduleReview/LegacyAutoPayScheduleReview'
import { PlatformAutoPayScheduleReview } from '@/src/experiences/card-payments/screens/AutoPayScheduleReview/PlatformAutoPayScheduleReview'

export function useAutoPayScheduleReviewScreenProps() {
  return usePaymentScreen(
    'autoPay/reviewAutoPay',
    'Review Auto-pay',
    '/main/card/card-management/payment',
  )
}

export type AutoPayScheduleReviewComponentType = FunctionComponent<{
  amount?: ComponentProps<typeof OptionItemSelector>['title']
  day?: ComponentProps<typeof OptionItemSelector>['title']
  account?: ComponentProps<typeof OptionItemSelector>['title']
  confirmRemoveAutoPay?: () => void
  loading?: boolean
}>

const AutoPayScheduleReview = provideCardPlatform<AutoPayScheduleReviewComponentType>(
  ({ ToWrap, platform }) => {
    switch (platform) {
      case 'HIGHNOTE':
        return <LegacyAutoPayScheduleReview AutoPayScheduleReviewComponent={ToWrap} />
      case 'LOANPRO':
        return <PlatformAutoPayScheduleReview AutoPayScheduleReviewComponent={ToWrap} />
      default:
        platform satisfies undefined
        return <ToWrap loading />
    }
  },
)(({ amount, day, account, confirmRemoveAutoPay, loading }) => {
  const { Modal } = useAutoPayScheduleReviewScreenProps()
  return Modal({
    children: (
      <ScrollView contentContainerStyle={{ paddingBottom: 50 }}>
        <PaymentCardInformation containerStyle={styles.container}>
          <OptionItemSelector label="Amount" title={amount} />
          <OptionItemSelector label="Next scheduled transfer date" title={day} />
          <OptionItemSelector label="Bank Account" title={account} withBorder={false} />
        </PaymentCardInformation>
        <Button
          segmentAction='User Pressed the "Cancel Auto Pay" button'
          title="Cancel Auto-pay schedule"
          onPress={confirmRemoveAutoPay}
          testID={CardPaymentsE2E.Ids.Press.CancelAutoPay}
          disabled={loading}
          loading={loading}
        />
        <Components.Agreement />
      </ScrollView>
    ),
  })
})

const styles = StyleSheet.create({
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: { marginHorizontal: 16, position: 'relative' },
})

export const AutoPayScheduleReviewScreen = {
  name: 'auto-pay-schedule',
  Screen: AutoPayScheduleReview,
} as const
